/* eslint-disable import/no-dynamic-require */
// import loadRequire from './loadRequire';
import BigNumber from 'bignumber.js';

// let promise;

export default function loadBigNumberJS() {
  // if (promise) {
  //   return promise;
  // }
  // promise = loadRequire().then((require) => {
  //   return new Promise((resolve) => {
  //     require(['bignumber'], resolve);
  //   });
  // });
  // return promise;
  // bignumber.js 在同步主包里已经有了，直接返回
  return Promise.resolve(BigNumber);
}
